import React, { useEffect, useState } from "react";
import { fetchRooms, updateRoom, fetchCleaners, fetchHousekeepingAttention, getRole } from "../services/api";
import { useT } from "../i18n/useT";

// Front Desk — Slice 3: housekeeping dashboard. Assign cleaners to rooms and
// track cleaned / not. Managers & front desk assign; housekeepers update status.
const S = {
  en: {
    title: "Housekeeping", subtitle: "Assign cleaners and track room readiness",
    st_dirty: "To clean", st_clean: "Clean", st_inspected: "Ready", st_out_of_order: "Out of order",
    assign: "Assign cleaner", unassigned: "Unassigned", cleaner: "Cleaner",
    total: "rooms", no_rooms: "No rooms yet. Add rooms under Front Desk › Room types & Rooms.",
    ready_hint: "Ready to sell", floor: "Floor", no_floor: "Unassigned",
    group_by: "Group by", group_type: "Room type", group_area: "Area", group_floor: "Floor", no_type: "No type", no_area: "No area",
    filter_all: "All", search_ph: "Search room # or guest", no_match: "No rooms match.",
    type_all: "All", room_type: "Room type",
    attention: "Needs attention", turndown: "Turndown (occupied rooms)", td_done: "Done", mark_done: "Mark done",
    r_arrival_not_ready: "Arrival — not ready", r_occupied_ooo: "Occupied but out of order", r_stayover_dirty: "Stayover — needs cleaning",
    oos_reason_q: "Reason it's out of order (optional):", oos_category_q: "Category — type one: maintenance / cleaning / other",
    cat_maintenance: "Maintenance", cat_cleaning: "Cleaning", cat_other: "Other", cancel: "Cancel", confirm: "Confirm",
    oos_category_label: "Category", oos_detail_label: "Details — what's wrong?", oos_maint_hint: "Visible to the maintenance team.", oos_maint_required: "Please describe the maintenance issue.",
    select_all: "Select all", clear_sel: "Clear", n_selected: "selected", mark_selected: "Mark selected as",
  },
  am: {
    title: "የክፍል አጽዳት", subtitle: "አጽጂዎችን መድብ እና የክፍል ዝግጁነት ተከታተል",
    st_dirty: "ማጽዳት ያለበት", st_clean: "ንጹህ", st_inspected: "ዝግጁ", st_out_of_order: "ከአገልግሎት ውጪ",
    assign: "አጽጂ መድብ", unassigned: "ያልተመደበ", cleaner: "አጽጂ",
    total: "ክፍሎች", no_rooms: "እስካሁን ክፍሎች የሉም። በፊት ዴስክ › ክፍሎች ስር ይጨምሩ።",
    ready_hint: "ለሽያጭ ዝግጁ", floor: "ፎቅ", no_floor: "ያልተመደበ",
    group_by: "በቡድን", group_type: "የክፍል ዓይነት", group_area: "አካባቢ", group_floor: "ፎቅ", no_type: "ዓይነት የለም", no_area: "አካባቢ የለም",
    filter_all: "ሁሉም", search_ph: "የክፍል # ወይም እንግዳ ይፈልጉ", no_match: "የሚዛመድ ክፍል የለም።",
    type_all: "ሁሉም", room_type: "የክፍል ዓይነት",
    attention: "ትኩረት የሚሹ", turndown: "የምሽት ዝግጅት (የተያዙ ክፍሎች)", td_done: "ተከናውኗል", mark_done: "እንደተከናወነ ምልክት",
    r_arrival_not_ready: "መግቢያ — ዝግጁ አይደለም", r_occupied_ooo: "ተይዟል ግን ከአገልግሎት ውጪ", r_stayover_dirty: "ቆይታ — ማጽዳት ያስፈልጋል",
    oos_reason_q: "ከአገልግሎት ውጪ የሆነበት ምክንያት (አማራጭ):", oos_category_q: "Category — type one: maintenance / cleaning / other",
    cat_maintenance: "Maintenance", cat_cleaning: "Cleaning", cat_other: "Other", cancel: "Cancel", confirm: "Confirm",
    oos_category_label: "Category", oos_detail_label: "Details — what's wrong?", oos_maint_hint: "Visible to the maintenance team.", oos_maint_required: "Please describe the maintenance issue.", // TODO verify am
    select_all: "ሁሉንም ምረጥ", clear_sel: "አጽዳ", n_selected: "ተመርጠዋል", mark_selected: "የተመረጡትን ምልክት አድርግ",
  },
  om: {
    title: "Qulqullina kutaa", subtitle: "Qulqulleessitoota ramadi, qophii kutaa hordofi",
    st_dirty: "Qulqulleeffamuu qabu", st_clean: "Qulqulluu", st_inspected: "Qophii", st_out_of_order: "Tajaajila ala",
    assign: "Qulqulleessaa ramadi", unassigned: "Hin ramadamne", cleaner: "Qulqulleessaa",
    total: "kutaalee", no_rooms: "Ammatti kutaan hin jiru. Fuula Duraa › Kutaalee jalatti dabali.",
    ready_hint: "Gurgurtaaf qophii", floor: "Darbii", no_floor: "Kan hin ramadamne",
    group_by: "Ramaddii", group_type: "Gosa kutaa", group_area: "Naannoo", group_floor: "Darbii", no_type: "Gosa hin qabu", no_area: "Naannoo hin qabu",
    filter_all: "Hunda", search_ph: "Lakk. kutaa yookaan keessummaa barbaadi", no_match: "Kutaan walsimu hin jiru.",
    type_all: "Hunda", room_type: "Gosa kutaa",
    attention: "Xiyyeeffannoo barbaadu", turndown: "Qophii galgalaa (kutaa qabaman)", td_done: "Xumurame", mark_done: "Xumurame godhi",
    r_arrival_not_ready: "Ga'umsa — hin qophoofne", r_occupied_ooo: "Qabame garuu tajaajila ala", r_stayover_dirty: "Turtii — qulqullina barbaada",
    oos_reason_q: "Sababa tajaajila ala ta'e (filannoo):", oos_category_q: "Category — type one: maintenance / cleaning / other",
    cat_maintenance: "Maintenance", cat_cleaning: "Cleaning", cat_other: "Other", cancel: "Cancel", confirm: "Confirm",
    oos_category_label: "Category", oos_detail_label: "Details — what's wrong?", oos_maint_hint: "Visible to the maintenance team.", oos_maint_required: "Please describe the maintenance issue.", // TODO verify om
    select_all: "Hunda fili", clear_sel: "Haqi", n_selected: "filataman", mark_selected: "Kan filataman mallatteessi",
  },
};

const CARD = { background: "#fff", border: "1px solid #eef2f2", borderRadius: 14, boxShadow: "0 1px 3px rgba(6,59,72,0.06)" };
const META = {
  dirty: { bg: "#FCEBEB", fg: "#A32D2D", dot: "#D9534F" },
  clean: { bg: "#E6F1FB", fg: "#185FA5", dot: "#3f8cff" },
  inspected: { bg: "#E7F6EC", fg: "#1D7A44", dot: "#22a37e" },
  out_of_order: { bg: "#EFEFF2", fg: "#5b6472", dot: "#8a94a3" },
};
// Priority order — rooms needing work first.
const ORDER = ["dirty", "clean", "inspected", "out_of_order"];

export default function HousekeepingPage() {
  const { lang } = useT();
  const t = (k) => (S[lang] && S[lang][k]) || S.en[k] || k;
  const role = getRole();
  const canAssign = role === "manager" || role === "front_desk" || role === "housekeeper";

  const [rooms, setRooms] = useState(null);
  const [cleaners, setCleaners] = useState([]);
  const [attn, setAttn] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");   // "all" | one of ORDER
  const [query, setQuery] = useState("");                     // room # / name / guest search
  const [typeFilter, setTypeFilter] = useState("all");        // "all" | room_type_name | "__none"
  // Out-of-order inline form: which room's form is open (by id) + its fields.
  // Only one open at a time; opened when "out of order" is chosen for a room.
  const [oosRoomId, setOosRoomId] = useState(null);
  const [oosCategory, setOosCategory] = useState("maintenance");
  const [oosDetail, setOosDetail] = useState("");
  const [oosErr, setOosErr] = useState("");
  // Bulk select — mark several rooms at once (Nigat #19). Map of room id -> true.
  const [sel, setSel] = useState({});

  // Two-axis layout. X-axis = room type (filter chips); Y-axis = floor (always
  // grouped by floor). Type key — the room's `room_type_name`, or "__none" bucket.
  const typeKey = (r) => (r.room_type_name || "").trim() || "__none";
  // Floor key — prefer the room's own `floor`; otherwise derive one from the
  // leading numeric part of the room number ("R008" → 0, "101" → 1, "1203" → 12).
  // Rooms with no number fall under an "Other" bucket.
  const floorKey = (r) => {
    if (r.floor != null && String(r.floor).trim() !== "") return String(r.floor).trim();
    const mm = String(r.name || "").match(/\d+/);
    if (!mm) return "__other";
    const num = mm[0];
    return num.length > 2 ? String(parseInt(num.slice(0, -2), 10)) : "0";
  };
  // Rooms are always grouped by floor. Empty/no-floor bucket sorts last.
  const groupLabel = (k) => (k === "__other" ? t("no_floor") : `${t("floor")} ${k}`);

  const load = () => fetchRooms().then(setRooms).catch(() => setRooms([]));
  const loadAttn = () => fetchHousekeepingAttention().then(setAttn).catch(() => setAttn(null));
  useEffect(() => {
    load();
    loadAttn();
    if (canAssign) fetchCleaners().then(setCleaners).catch(() => setCleaners([]));
  }, [canAssign]);

  const setTurndown = async (roomId, v) => {
    try { await updateRoom(roomId, { turndown: v }); } catch { /* ignore */ }
    loadAttn();
  };

  // Direct status change for clean/dirty/inspected. "out_of_order" no longer
  // routes through here — it opens the inline form (openOOO) instead.
  const setStatus = async (room, status) => {
    setRooms((rs) => rs.map((r) => (r.id === room.id ? { ...r, status } : r)));
    try {
      await updateRoom(room.id, { status });
    } catch { load(); }
  };

  // Open the inline out-of-order form for a room (default category maintenance).
  const openOOO = (room) => {
    setOosRoomId(room.id);
    setOosCategory("maintenance");
    setOosDetail("");
    setOosErr("");
  };
  const cancelOOO = () => {
    setOosRoomId(null);
    setOosErr("");
  };
  const confirmOOO = async (room) => {
    const detail = oosDetail.trim();
    // Detail is required when the category is maintenance (it becomes the
    // maintenance ticket's reason); optional for cleaning / other.
    if (oosCategory === "maintenance" && !detail) {
      setOosErr(t("oos_maint_required"));
      return;
    }
    setOosRoomId(null);
    setOosErr("");
    setRooms((rs) => rs.map((r) => (r.id === room.id ? { ...r, status: "out_of_order", oos_reason: detail, oos_category: oosCategory } : r)));
    try {
      await updateRoom(room.id, { status: "out_of_order", oos_category: oosCategory, oos_reason: detail });
    } catch { load(); }
  };
  const assign = async (room, staffId) => {
    const id = staffId ? Number(staffId) : 0;
    setRooms((rs) => rs.map((r) => (r.id === room.id ? { ...r, assigned_cleaner_staff_id: id || null } : r)));
    try { await updateRoom(room.id, { assigned_cleaner_staff_id: id }); } catch { load(); }
  };

  const counts = ORDER.reduce((a, s) => ({ ...a, [s]: (rooms || []).filter((r) => r.status === s).length }), {});
  // X-axis room-type chips: distinct types present + counts. "__none" bucket last.
  const typeCounts = (rooms || []).reduce((a, r) => { const k = typeKey(r); a[k] = (a[k] || 0) + 1; return a; }, {});
  const typeKeys = Object.keys(typeCounts).sort((a, b) => (a === "__none" ? 1 : b === "__none" ? -1 : a.localeCompare(b)));
  const inp = { padding: 7, borderRadius: 8, border: "1px solid #d8dee2", fontSize: 13 };

  // Rooms surviving the active type + status + search filters. Computed here (not
  // only in the render) so "select all" can target exactly what's on screen.
  const q = query.trim().toLowerCase();
  const visible = (rooms || []).filter((r) => {
    if (typeFilter !== "all" && typeKey(r) !== typeFilter) return false;
    if (statusFilter !== "all" && r.status !== statusFilter) return false;
    if (!q) return true;
    return `${r.name || ""} ${r.guest_name || ""}`.toLowerCase().includes(q);
  });
  // Bulk-select helpers.
  const selIds = Object.keys(sel).filter((k) => sel[k]);
  const selCount = selIds.length;
  const visibleIds = visible.map((r) => String(r.id));
  const allVisibleSelected = visibleIds.length > 0 && visibleIds.every((id) => sel[id]);
  const toggleSel = (id) => setSel((m) => ({ ...m, [id]: !m[id] }));
  const clearSel = () => setSel({});
  const toggleSelectAll = () => {
    if (allVisibleSelected) { clearSel(); return; }
    const next = {};
    visibleIds.forEach((id) => { next[id] = true; });
    setSel(next);
  };
  const bulkSet = async (status) => {
    const ids = selIds.map(Number);
    if (!ids.length) return;
    // Out-of-order needs a reason/category per room, so it's excluded from bulk.
    setRooms((rs) => rs.map((r) => (ids.includes(r.id) ? { ...r, status } : r)));
    clearSel();
    try { await Promise.all(ids.map((id) => updateRoom(id, { status }))); }
    catch { load(); }
  };

  return (
    <div style={{ maxWidth: 1040, margin: "0 auto" }}>
      <h1 style={{ marginBottom: 2 }}>{t("title")}</h1>
      <div className="muted" style={{ fontSize: 14 }}>{t("subtitle")}</div>

      {rooms && rooms.length > 0 && (
        <>
          {/* X-axis: room-type chips (primary) */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 14 }}>
            <span className="muted" style={{ fontSize: 13, alignSelf: "center" }}>{t("room_type")}:</span>
            <span onClick={() => setTypeFilter("all")}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer", background: typeFilter === "all" ? "#063b48" : "#eef2f2", color: typeFilter === "all" ? "#fff" : "#334", borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 600, border: typeFilter === "all" ? "1.5px solid #063b48" : "1.5px solid transparent" }}>
              {t("type_all")} · {rooms.length}
            </span>
            {typeKeys.map((k) => (
              <span key={k} onClick={() => setTypeFilter(k)}
                style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer", background: typeFilter === k ? "#063b48" : "#eef2f2", color: typeFilter === k ? "#fff" : "#334", borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 600, border: typeFilter === k ? "1.5px solid #063b48" : "1.5px solid transparent" }}>
                {k === "__none" ? t("no_type") : k} · {typeCounts[k]}
              </span>
            ))}
          </div>
          {/* Secondary: status chips */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10 }}>
            <span className="muted" style={{ fontSize: 13, alignSelf: "center" }}>{rooms.length} {t("total")}:</span>
            <span onClick={() => setStatusFilter("all")}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer", background: statusFilter === "all" ? "#063b48" : "#eef2f2", color: statusFilter === "all" ? "#fff" : "#334", borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 600, border: statusFilter === "all" ? "1.5px solid #063b48" : "1.5px solid transparent" }}>
              {t("filter_all")} · {rooms.length}
            </span>
            {ORDER.map((s) => (
              <span key={s} onClick={() => setStatusFilter(s)}
                style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer", background: META[s].bg, color: META[s].fg, borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 600, border: statusFilter === s ? `1.5px solid ${META[s].dot}` : "1.5px solid transparent" }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: META[s].dot }} /> {counts[s]} {t("st_" + s)}
              </span>
            ))}
          </div>
          <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder={t("search_ph")}
            style={{ ...inp, marginTop: 10, width: 260, maxWidth: "100%", display: "block" }} />

          {/* Bulk select — mark several rooms at once (#19). */}
          {canAssign && visible.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", marginTop: 10, padding: "8px 10px", background: "#f4f7f7", borderRadius: 10 }}>
              <label style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer", fontWeight: 600 }}>
                <input type="checkbox" checked={allVisibleSelected} onChange={toggleSelectAll} />
                {t("select_all")}
              </label>
              {selCount > 0 && (
                <>
                  <span className="muted" style={{ fontSize: 13 }}>· {selCount} {t("n_selected")}</span>
                  <span style={{ fontSize: 13, color: "#5b6472" }}>{t("mark_selected")}:</span>
                  {["dirty", "clean", "inspected"].map((st) => (
                    <button key={st} onClick={() => bulkSet(st)}
                      style={{ fontSize: 12.5, padding: "4px 10px", borderRadius: 8, cursor: "pointer", border: `1px solid ${META[st].dot}`, background: META[st].bg, color: META[st].fg, fontWeight: 600 }}>
                      {t("st_" + st)}
                    </button>
                  ))}
                  <button onClick={clearSel} style={{ fontSize: 12.5, padding: "4px 10px", borderRadius: 8, cursor: "pointer", border: "1px solid #e2e6ea", background: "#fff", color: "#5b6472" }}>
                    {t("clear_sel")}
                  </button>
                </>
              )}
            </div>
          )}
        </>
      )}

      {attn && attn.discrepancies && attn.discrepancies.length > 0 && (
        <div style={{ ...CARD, padding: 14, marginTop: 14, borderLeft: "4px solid #B8860B" }}>
          <div style={{ fontWeight: 700, marginBottom: 8, color: "#8A6D3B" }}>⚠ {t("attention")} · {attn.discrepancies.length}</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
            {attn.discrepancies.map((x, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: 10, fontSize: 13.5, borderBottom: "1px solid #f2f5f5", paddingBottom: 4 }}>
                <span><b>{x.room_name}</b>{x.room_type_name ? ` · ${x.room_type_name}` : ""}{x.guest_name ? ` · ${x.guest_name}` : ""}</span>
                <span style={{ color: "#A32D2D", fontWeight: 600, whiteSpace: "nowrap" }}>{t("r_" + x.reason)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {attn && attn.turndown && attn.turndown.length > 0 && (
        <div style={{ ...CARD, padding: 14, marginTop: 12 }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>{t("turndown")} · {(attn.counts && attn.counts.turndown_pending) || 0}</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 8 }}>
            {attn.turndown.map((x) => (
              <div key={x.room_id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", border: "1px solid #eef2f2", borderRadius: 8, padding: "8px 10px" }}>
                <span style={{ fontSize: 13.5, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}><b>{x.room_name}</b> · {x.guest_name}</span>
                {x.turndown === "done"
                  ? <button className="btn secondary small" onClick={() => setTurndown(x.room_id, "pending")} style={{ color: "#1D7A44" }}>✓ {t("td_done")}</button>
                  : <button className="btn secondary small" onClick={() => setTurndown(x.room_id, "done")}>{t("mark_done")}</button>}
              </div>
            ))}
          </div>
        </div>
      )}

      {rooms == null ? (
        <p className="muted" style={{ marginTop: 16 }}>…</p>
      ) : rooms.length === 0 ? (
        <div style={{ ...CARD, padding: 20, marginTop: 16, textAlign: "center" }} className="muted">{t("no_rooms")}</div>
      ) : (() => {
        // Presentational only: `visible` (computed above) is the active type +
        // status + search filter; group the surviving rooms by floor (Y-axis).
        if (visible.length === 0) {
          return <div style={{ ...CARD, padding: 20, marginTop: 16, textAlign: "center" }} className="muted">{t("no_match")}</div>;
        }
        const groups = {};
        visible.forEach((r) => { const k = floorKey(r); (groups[k] = groups[k] || []).push(r); });
        const keys = Object.keys(groups).sort((a, b) => {
          if (a === "__other") return 1;
          if (b === "__other") return -1;
          const na = Number(a), nb = Number(b);
          if (!isNaN(na) && !isNaN(nb)) return na - nb;
          return a.localeCompare(b);
        });
        return keys.map((k) => (
          <div key={k} style={{ marginTop: 18 }}>
            <div style={{ fontSize: 12.5, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: "#063b48", marginBottom: 8 }}>
              {groupLabel(k)} · {groups[k].length}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 12 }}>
              {groups[k].map((r) => {
                const m = META[r.status] || META.clean;
                return (
                  <div key={r.id} style={{ ...CARD, padding: 14, borderLeft: `4px solid ${m.dot}` }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {canAssign && (
                          <input type="checkbox" checked={!!sel[r.id]} onChange={() => toggleSel(String(r.id))}
                            title={t("select_all")} style={{ cursor: "pointer" }} />
                        )}
                        <div style={{ fontSize: 19, fontWeight: 700, color: "#063b48" }}>{r.name}</div>
                      </div>
                      <span style={{ background: m.bg, color: m.fg, borderRadius: 20, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>{t("st_" + r.status)}</span>
                    </div>
                    <div className="muted" style={{ fontSize: 13, marginTop: 2 }}>
                      {r.room_type_name || "—"}{r.floor ? ` · ${t("floor")} ${r.floor}` : ""}
                    </div>

                    {/* cleaner assignment */}
                    <div style={{ marginTop: 10 }}>
                      {canAssign ? (
                        <select style={{ ...inp, width: "100%" }} value={r.assigned_cleaner_staff_id || ""} onChange={(e) => assign(r, e.target.value)}>
                          <option value="">{t("assign")}: {t("unassigned")}</option>
                          {cleaners.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                      ) : (
                        <div style={{ fontSize: 13, color: "#5b6472" }}>{t("cleaner")}: {r.assigned_cleaner_name || t("unassigned")}</div>
                      )}
                    </div>

                    {/* status buttons */}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 10 }}>
                      {ORDER.map((st) => (
                        <button key={st} onClick={() => (st === "out_of_order" ? openOOO(r) : setStatus(r, st))}
                          style={{
                            fontSize: 12, padding: "4px 9px", borderRadius: 8, cursor: "pointer",
                            border: r.status === st ? `1.5px solid ${META[st].dot}` : "1px solid #e2e6ea",
                            background: r.status === st ? META[st].bg : "#fff",
                            color: r.status === st ? META[st].fg : "#5b6472",
                            fontWeight: r.status === st ? 700 : 500,
                          }}>
                          {t("st_" + st)}
                        </button>
                      ))}
                    </div>

                    {/* Inline out-of-order form (replaces the old window.prompt flow) */}
                    {oosRoomId === r.id && (
                      <div style={{ marginTop: 10, padding: 10, background: "#f7f9f9", border: "1px solid #eef2f2", borderRadius: 10 }}>
                        <label style={{ display: "block", fontSize: 12, color: "#5b6472", marginBottom: 4 }}>{t("oos_category_label")}</label>
                        <select value={oosCategory} onChange={(e) => setOosCategory(e.target.value)} style={{ ...inp, width: "100%", boxSizing: "border-box" }}>
                          <option value="maintenance">{t("cat_maintenance")}</option>
                          <option value="cleaning">{t("cat_cleaning")}</option>
                          <option value="other">{t("cat_other")}</option>
                        </select>
                        <label style={{ display: "block", fontSize: 12, color: "#5b6472", marginTop: 8, marginBottom: 4 }}>{t("oos_detail_label")}</label>
                        <textarea value={oosDetail} onChange={(e) => setOosDetail(e.target.value)} rows={2} autoFocus
                          style={{ ...inp, width: "100%", boxSizing: "border-box", resize: "vertical" }} />
                        {oosCategory === "maintenance" && <div className="muted" style={{ fontSize: 11.5, marginTop: 4 }}>{t("oos_maint_hint")}</div>}
                        {oosErr && <div style={{ color: "#A32D2D", fontSize: 12, marginTop: 4 }}>{oosErr}</div>}
                        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                          <button className="btn primary small" onClick={() => confirmOOO(r)}>{t("confirm")}</button>
                          <button className="btn secondary small" onClick={cancelOOO}>{t("cancel")}</button>
                        </div>
                      </div>
                    )}
                    {r.status === "inspected" && <div style={{ fontSize: 12, color: "#1D7A44", fontWeight: 600, marginTop: 6 }}>✓ {t("ready_hint")}</div>}
                  </div>
                );
              })}
            </div>
          </div>
        ));
      })()}
    </div>
  );
}
